import { AutogenLayoutdpRenbSummary } from "./autogen/AutogenLayoutdpRenbSummary";

export class dpRenbSummary extends AutogenLayoutdpRenbSummary {

  override async onLoad() {
    //Not Processed
    await this.sourceRenbill.search({ renb_done: "N", renb_billtype: "S" });
    this.textboxRendRecsSum.text = this.sourceRenbill.actualRowCount.toString();
    //Processed
    await this.sourceRenbill.search({ renb_done: "Y", renb_billtype: "S" });
    this.textboxRendProcSum.text = this.sourceRenbill.actualRowCount.toString();
    //Total
    await this.sourceRenbill.search({ renb_billtype: "S" });
    this.textboxRendTotalSum.text = this.sourceRenbill.actualRowCount.toString();
  }

}
